<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading() }"
>
  <!-- Card Header -->
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        {{ data.request.patient_first_name }} {{ data.request.patient_last_name }}
      </h3>
    </div>
  </div>

  <!-- Card Body -->
  <div style="min-height: 200px !important" class="card-body pt-15">
    <!-- Loading Spinner -->
    <div class="card-body-progress" *ngIf="viewLoading()">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <!-- Request Details -->
    <div *ngIf="!viewLoading()">
      <!-- Request Information -->
      <div class="row mb-4">
        <div class="col-md-6">
          <p><strong>Requested Date:</strong> {{ data.request.created | date : 'medium' }}</p>
        </div>
        <div class="col-md-6">
          <p><strong>Requestor Name:</strong> {{ user.fullName }}</p>
        </div>
      </div>

      <!-- Images Comparison -->
      <div class="row align-items-center">
        <!-- Current Image -->
        <div *ngIf="data.request.previous_avatar_url" class="col-md-5 text-center">
          <img
            id="current_avatar"
            alt="Current Avatar"
            class="img-fluid rounded shadow"
            [src]="data.request.previous_avatar_url"
          />
          <p class="mt-2 text-muted">Current Image</p>
        </div>

        <!-- Arrow -->
        <div *ngIf="data.request.previous_avatar_url" class="col-md-2 text-center">
          <div class="arrow-container">
            <i class="arrow-icon">&rarr;</i>
          </div>
        </div>

        <!-- New Image -->
        <div
          class="col-md-{{ data.request.previous_avatar_url == null ? '12' : '5' }}  text-center"
        >
          <img
            id="new_avatar_url"
            alt="New Avatar"
            class="img-fluid rounded shadow"
            [src]="data.request.new_avatar_url"
          />
          <p class="mt-2 text-muted">New Image</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Footer -->
  <div tabindex="0" class="card-footer d-flex justify-content-between">
    <div>
      <button
        #cancelButton
        mat-raised-button
        cdkFocusInitial
        style="width: 100px !important"
        class="btn btn-sm btn-light"
        (click)="onNoClick()"
      >
        {{ 'GLOBAL.CANCEL' | translate }}
      </button>
    </div>
    <div>
      <button
        mat-raised-button
        style="width: 100px !important"
        class="btn btn-sm btn-danger mr-2"
        [disabled]="!data.request.actions.includes('approve')"
        (click)="denyRequest()"
      >
        Deny
      </button>
      <button
        mat-raised-button
        style="width: 100px !important"
        class="btn btn-sm btn-success"
        [disabled]="!data.request.actions.includes('approve')"
        (click)="approveRequest()"
      >
        Approve
      </button>
    </div>
  </div>
</div>
